'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import { tableRowStyles } from './Table.styles'
import { useTableColorScheme, useTableDensity } from './TableContext'

export type TableRowProps = {
  children: React.ReactNode
  onClick?: () => void
  isSelected?: boolean
  isAlternate?: boolean
}

export const TableRow = ({
  children,
  onClick,
  isSelected = false,
  isAlternate = false,
}: TableRowProps) => {
  const colorScheme = useTableColorScheme()
  const density = useTableDensity()
  return (
    <Box
      {...tableRowStyles(
        colorScheme,
        !!onClick,
        isSelected,
        isAlternate,
        density
      )}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e: React.KeyboardEvent) => {
              if (
                e.target === e.currentTarget &&
                (e.key === 'Enter' || e.key === ' ')
              ) {
                e.preventDefault()
                onClick()
              }
            }
          : undefined
      }
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </Box>
  )
}
